export default __webpack_public_path__ + "static/media/hexagon.10332f2a.svg";